function Videos(props){
    return (
        <div id="videos">
            <h2>Communal Video</h2>
            <div id="video-corral">
    
            </div>
        </div>
    )
}

export default Videos;